export const contractApiEndpoints = {
  list: { method: 'GET', path: '/staff/contracts', requiresAuth: true },
  detail: { method: 'GET', path: '/staff/contracts/:id', requiresAuth: true },
  create: { method: 'POST', path: '/staff/contracts', requiresAuth: true },
  update: { method: 'PUT', path: '/staff/contracts/:id', requiresAuth: true },
  remove: { method: 'DELETE', path: '/staff/contracts/:id', requiresAuth: true },
  send: { method: 'POST', path: '/staff/contracts/:id/send', requiresAuth: true },
  approve: { method: 'POST', path: '/staff/contracts/:id/approve', requiresAuth: true },
  reject: { method: 'POST', path: '/staff/contracts/:id/reject', requiresAuth: true },
  sign: { method: 'POST', path: '/staff/contracts/:id/sign', requiresAuth: true },
  documents: { method: 'GET', path: '/staff/contracts/:id/documents', requiresAuth: true },
  presignDocument: {
    method: 'POST',
    path: '/staff/contracts/:id/documents/presign',
    requiresAuth: true,
  },
  renew: { method: 'POST', path: '/staff/contracts/:id/renew', requiresAuth: true },
  terminate: { method: 'POST', path: '/staff/contracts/:id/terminate', requiresAuth: true },
  events: { method: 'GET', path: '/staff/contracts/:id/events', requiresAuth: true },
  types: { method: 'GET', path: '/staff/contracts/types', requiresAuth: true },
  createType: { method: 'POST', path: '/staff/contracts/types', requiresAuth: true },
  updateType: { method: 'PUT', path: '/staff/contracts/types/:id', requiresAuth: true },
  deleteType: { method: 'DELETE', path: '/staff/contracts/types/:id', requiresAuth: true },
} as const
